// © 2015-2021 WDNA - All Rights Reserved

import * as React from 'react';

/**
 * Returns an error 404 react component
 *
 * @returns react node
 */
export default function Error404(): JSX.Element {
  return (
    <div className="error-404-page">
      <h1>404 Error - Page Not Found</h1>
      <h3>Something went wrong!</h3>
    </div>
  );
}
